/** Codes langue interface + analyse IA (`analyzeSituation`). Ordre : ISO 639-1 alphabétique. */
export const APP_LANGUAGE_CODES = [
	'de',
	'en',
	'es',
	'fr',
	'hi',
	'it',
	'ja',
	'pt',
	'zh'
] as const;

export type AppLanguageCode = (typeof APP_LANGUAGE_CODES)[number];

/** Libellés dans la langue elle-même (liste déroulante profil, repères visuels). */
export const LANGUAGE_NATIVE_LABELS: Record<AppLanguageCode, string> = {
	de: 'Deutsch',
	en: 'English',
	es: 'Español',
	fr: 'Français',
	hi: 'हिन्दी',
	it: 'Italiano',
	ja: '日本語',
	pt: 'Português',
	zh: '中文（普通话）'
};
